module.exports = __webpack_public_path__ + "images/FUSA_icons/047-online-shop-3.03ded717e63928280f1c22c268044f9b.svg";